import { sendContainerRequest } from '@/container'

type AccountRelationship = {
    relationship: string
    mainAccountId: string
}

export type AccountDetail = {
    id: string
    userId: string
    email: string
    fullName: string
    username: string
    relationships: AccountRelationship[]
    isMainAccount?: boolean
}

export type GetSubAccountsByUserResponse = {
    success: boolean
    data: {
        user: AccountDetail
        mainAccounts: AccountDetail[]
        subAccounts: AccountDetail[]
    }
    error?: string
}

export async function getSubAccountsByUser(
    userId: string
): Promise<GetSubAccountsByUserResponse> {
    return sendContainerRequest('getSubAccountsByUser', { userId })
        .then((result) => {
            if (result.data.success) {
                return result.data
            }
            return { success: false, error: result.data.error }
        })
        .catch((err) => ({ success: false, error: err }))
}
